export const WEB_LOCALE_LOADERS = {
	"de-DE": () => import("./locales/de-DE"),
	"es-ES": () => import("./locales/es-ES"),
	"fr-FR": () => import("./locales/fr-FR"),
	"pt-BR": () => import("./locales/pt-BR"),
	"nl-NL": () => import("./locales/nl-NL"),
	"da-DK": () => import("./locales/da-DK"),
};
